import api from '@services/api';
import { DetailsRequest, UndoUnionDetailsRequest, UnitDetailsRequest } from '../models/details';
import { DetailsTrainingResponse, DetailsTrainingTransfer, DetailsTrainingUpdate } from '../models/detailsTraining';

/**
 * <p>
 * API endpoints that cover all training related CRUD calls
 */
export const detailsTrainingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchDetailsTraining: builder.query<DetailsTrainingResponse, DetailsRequest>({
      query: (params: DetailsRequest) => ({
        url: encodeURI(
          `/report/details-training/search?project=${params.project}&period=${params.period}&subGroup=${params.subGroup}&searchTerm=${params.searchTerm}`,
        ),
      }),
      providesTags: ['SearchDetailsTraining', 'SearchDetails'],
    }),
    unitTraining: builder.mutation<void, UnitDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-training/group`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsTraining'],
    }),
    undoUnionTraining: builder.mutation<void, UndoUnionDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-training/ungroup`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsTraining'],
    }),
    updateDetailsTraining: builder.mutation<void, DetailsTrainingUpdate>({
      query: (project) => ({
        url: encodeURI(`/report/details-training/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsTraining'],
    }),
    trainingTransfer: builder.mutation<void, DetailsTrainingTransfer>({
      query: (project) => ({
        url: encodeURI(`/report/details-training/transfer`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsTraining', 'SearchDetails'],
    }),
  }),
});

export const {
  useSearchDetailsTrainingQuery,
  useUnitTrainingMutation,
  useUndoUnionTrainingMutation,
  useUpdateDetailsTrainingMutation,
  useTrainingTransferMutation,
} = detailsTrainingApi;
